import {Injectable} from '@angular/core';
import {AlertController} from '@ionic/angular';

@Injectable()
export class OptionsHandlerService {
    newDocument: any;


    constructor(public alertCtrl: AlertController) {

    }

    validOptionChosen(newDocument: any) {
        let valid = true;
        if (newDocument.checkBoxOptionsBean.option1 === false &&
            newDocument.checkBoxOptionsBean.option2 === false &&
            newDocument.checkBoxOptionsBean.option3 === false) {
            valid = false;
        }

        if (newDocument.checkBoxOptionsBean.option4 === false &&
            newDocument.checkBoxOptionsBean.option5 === false &&
            newDocument.checkBoxOptionsBean.option6 === false) {
            valid = false;
        }

        return valid;
    }

    assignOptionForNewDocument(newDocument: any, optionNumber: number) {
        switch (optionNumber) {
            case 1:
                newDocument.checkBoxOptionsBean.option1 = true;
                newDocument.checkBoxOptionsBean.option2 = false;
                newDocument.checkBoxOptionsBean.option3 = false;
                break;
            case 2:
                newDocument.checkBoxOptionsBean.option1 = false;
                newDocument.checkBoxOptionsBean.option2 = true;
                newDocument.checkBoxOptionsBean.option3 = false;
                break;
            case 3:
                newDocument.checkBoxOptionsBean.option1 = false;
                newDocument.checkBoxOptionsBean.option2 = false;
                newDocument.checkBoxOptionsBean.option3 = true;
                break;
            case 4:
                newDocument.checkBoxOptionsBean.option4 = true;
                newDocument.checkBoxOptionsBean.option5 = false;
                newDocument.checkBoxOptionsBean.option6 = false;
                break;
            case 5:
                newDocument.checkBoxOptionsBean.option4 = false;
                newDocument.checkBoxOptionsBean.option5 = true;
                newDocument.checkBoxOptionsBean.option6 = false;
                break;
            case 6:
                newDocument.checkBoxOptionsBean.option4 = false;
                newDocument.checkBoxOptionsBean.option5 = false;
                newDocument.checkBoxOptionsBean.option6 = true;
                break;

            default:
                break;
        }
        return newDocument;
    }


    invalidOptionPopup() {
        alert('Please answer all questions');
    }

}
